import React from 'react';
import { OurIngredientsNew, SeeMoreIng } from '../../../Constants';
import { useTranslation } from 'react-i18next';
import CustomLink from '../../CustomLink';

const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
const INGREDIENT_IMAGES = {
  vitaminD: `${PUBLIC_URL}resources/images/blog/vitamin-D3-microgranules.jpg`,
  probiotics: `${PUBLIC_URL}resources/images/blog/probioticsis2-akjjk1b1qh-81i6a.jpg`,
  magnesium: `${PUBLIC_URL}resources/images/blog/magnesium-microgranules.jpg`,
  ashwagandha: `${PUBLIC_URL}resources/images/blog/ashwagandha-microgranules.jpg`,
};

const IngredientsSlider = () => {
  const { t } = useTranslation();

  const ingredients = [
    {
      id: 26,
      nameKey: 'HomeIngredientsSlider_VitaminD_Name',
      descKey: 'HomeIngredientsSlider_VitaminD_Desc',
      image: INGREDIENT_IMAGES.vitaminD,
    },
    {
      id: 2,
      nameKey: 'HomeIngredientsSlider_Probiotics_Name',
      descKey: 'HomeIngredientsSlider_Probiotics_Desc',
      image: INGREDIENT_IMAGES.probiotics,
    },
    {
      id: 3,
      nameKey: 'HomeIngredientsSlider_Magnesium_Name',
      descKey: 'HomeIngredientsSlider_Magnesium_Desc',
      image: INGREDIENT_IMAGES.magnesium,
    },
    {
      id: 4,
      nameKey: 'HomeIngredientsSlider_Ashwagandha_Name',
      descKey: 'HomeIngredientsSlider_Ashwagandha_Desc',
      image: INGREDIENT_IMAGES.ashwagandha,
    },
  ];

  const marqueeItems = [
    ...ingredients,
    {
      id: 'see-more',
      isSeeMore: true,
    },
  ];

  return (
    <div className="t-overflow-hidden">
      <div className="ingredients-marquee">
        {[...marqueeItems, ...marqueeItems].map((item, index) => {
          if (item.isSeeMore) {
            return (
              <CustomLink
                key={`see-more-${index}`}
                to="/ingredients"
                className="t-w-fit t-flex t-items-center t-gap-2 t-bg-white t-py-2 t-px-4 t-rounded-lg t-flex-shrink-0 t-mr-4"
              >
                <img src={`${PUBLIC_URL}resources/images/blog/conezyme-Q10-microgranules.jpg`} alt="" className="t-w-16 t-h-16 t-rounded-lg t-object-cover" />
                <div className="t-flex t-flex-col">
                  <p className="!t-m-0 t-text-navy t-font-sans t-font-extrabold">
                    {t(SeeMoreIng)}
                  </p>
                  <p className="!t-m-0 t-font-sans t-text-navy/70">{t(OurIngredientsNew)}</p>
                </div>
              </CustomLink>
            );
          }

          return (
            <div
              key={`homepage-ing-${item.id}-${index}`}
              className="t-w-fit t-flex t-items-center t-gap-2 t-bg-white t-py-2 t-px-4 t-rounded-lg t-flex-shrink-0 t-mr-4"
            >
              <img src={item.image} alt={t(item.nameKey)} className="t-w-16 t-h-16 t-rounded-lg t-object-cover" />
              <div className="t-flex t-flex-col t-whitespace-nowrap">
                <p className="!t-m-0 t-text-navy t-font-sans t-font-extrabold">
                  {t(item.nameKey)}
                </p>
                <p className="!t-m-0 t-font-sans t-text-navy/70">{t(item.descKey)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IngredientsSlider;
